import React from 'react'
import { ElfsightWidget } from 'react-elfsight-widget';

const GoogleReviews = () => {
    return (
        <ElfsightWidget widgetId="3e4a0dab-be9e-4346-8a0c-e385dd2741f0" lazy={true} />
    )
}

export default GoogleReviews